import * as React from "react";
const BagIcon = (props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5003 5.41797C12.0403 5.41797 11.667 5.04464 11.667 4.58464V3.33464H8.33366V4.58464C8.33366 5.04464 7.96033 5.41797 7.50033 5.41797C7.04033 5.41797 6.66699 5.04464 6.66699 4.58464V3.33464C6.66699 2.41547 7.41449 1.66797 8.33366 1.66797H11.667C12.5862 1.66797 13.3337 2.41547 13.3337 3.33464V4.58464C13.3337 5.04464 12.9603 5.41797 12.5003 5.41797Z"
      fill="#B72840"
    />
    <path
      d="M10.5917 12.8169C10.4417 12.8753 10.225 12.9169 10 12.9169C9.775 12.9169 9.55833 12.8753 9.35833 12.8003L0 9.68359V16.0419C0 17.3086 1.025 18.3336 2.29167 18.3336H17.7083C18.975 18.3336 20 17.3086 20 16.0419V9.68359L10.5917 12.8169Z"
      fill="#B72840"
    />
    <path
      d="M20 6.45964V8.36797L10.2 11.6346C10.1333 11.6596 10.0667 11.668 10 11.668C9.93333 11.668 9.86667 11.6596 9.8 11.6346L0 8.36797V6.45964C0 5.19297 1.025 4.16797 2.29167 4.16797H17.7083C18.975 4.16797 20 5.19297 20 6.45964Z"
      fill="#B72840"
    />
  </svg>
);
export default BagIcon;
